/* eslint-disable no-unused-vars */
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import "./assets/css/style.css";

import Dashboard from "./pages/Dashboard";
import CalendarPage from "./pages/CalendarPage";
import Vacancies from "./pages/Leasing/Vacancies";
import LoginPage from "./pages/generalPages/LoginPage";
import UserPhoneVerification from "./pages/generalPages/UserPhoneVerification";
import PropertiesPage from "./pages/PropertiesPage";

import MySettings from "./pages/UserProfile/MySettings";
import AccountingSettings from "./pages/UserProfile/AccountingSettings";
import AccountingPeriods from "./pages/UserProfile/AccountingPeriods";
import ManagementFeeSettings from "./pages/UserProfile/ManagementFeeSettings";
import ManageUsers from "./pages/UserProfile/ManageUsers";
import WhatsNewPage from "./pages/WhatsNewPage";

import Leases from "./pages/Leasing/Leases";
import GuestCards from "./pages/Leasing/GuestCards";
import RentalApplications from "./pages/Leasing/RentalApplications";
import NewRentalApplications from "./pages/Leasing/RentalApplications/NewRentalApplications";
import Renewals from "./pages/Leasing/Renewals";
import ManageRoles from "./pages/UserProfile/UserRolesAndPermissions";
import BillsApprovalFlow from "./pages/UserProfile/BillsApprovalFlow";
import MainLayout from "./MainLayout";
import Leasing from "./pages/Leasing";
import People from "./pages/People";
import Tenants from "./pages/People/Tenants";
import Owners from "./pages/People/Owners";
import Vendors from "./pages/People/Vendors";
import Accounting from "./pages/Accounting";
import Receivables from "./pages/Accounting/Receivables";
import Payables from "./pages/Accounting/Payables";
import BankTransfers from "./pages/Accounting/BankTransfers";
import GLAccounts from "./pages/Accounting/GLAccounts";
import Maintenance from "./pages/Maintenance";
import WorkOrders from "./pages/Maintenance/WorkOrders";
import RecurringWorkOrders from "./pages/Maintenance/RecurringWorkOrders";
import Inspections from "./pages/Maintenance/Inspections";
import UnitTurns from "./pages/Maintenance/UnitTurns";
import Reporting from "./pages/Reporting";
import ScheduledReports from "./pages/Reporting/ScheduledReports";
import Surveys from "./pages/Reporting/Surveys";
import Reports from "./pages/Reporting/Reports";
import Metrics from "./pages/Reporting/Metrics";
import Communication from "./pages/Communication";
import ResidentForms from "./pages/Communication/ResidentForms";
import Letters from "./pages/Communication/Letters";
import Messages from "./pages/Communication/Messages";
import PropertyGroups from "./pages/UserProfile/PropertyGroups";
import NewPropertyGroups from "./pages/UserProfile/NewPropertyGroups";
import ManageCompanySettings from "./pages/UserProfile/ManageCompanySettings";
import CompanySettings from "./pages/UserProfile/ManageCompanySettings/CompanySettings";
import LogoSettings from "./pages/UserProfile/ManageCompanySettings/LogoSettings";
import Portfolio from "./pages/UserProfile/ManageCompanySettings/Portfolio/Portfolio";
import GeneralSettings from "./pages/UserProfile/GeneralSettings";
import AgreementTemplates from "./pages/UserProfile/AgreementTemplates";
import GlAccountPermissions from "./pages/UserProfile/GlAccountPermissions";
import NewUser from "./pages/UserProfile/NewUser";
import RentalApplicationFees from "./pages/UserProfile/RentalApplicationFees";
import UpdateApplicationFees from "./pages/Leasing/RentalApplications/BulkUpdateApplicationFees";
import ScreeningCriteria from "./pages/UserProfile/ScreeningCriteria";
import Template from "./pages/UserProfile/ScreeningCriteria/Template";
import PricingMetrics from "./pages/Reporting/Metrics/PricingMetrics";
import DataDiagnostic from "./pages/Reporting/Metrics/DataDiagnostic";
import TenantInsCoverage from "./pages/Reporting/Metrics/TenantInsuranceCoverage";
import ReceivablePayments from "./pages/Accounting/Receivables/Payments";
import ReceivableInvoices from "./pages/Accounting/Receivables/Invoices";
import ReceivableBankDeposits from "./pages/Accounting/Receivables/BankDeposits";
import PayablesInvoices from "./pages/Accounting/Payables/Invoices";
import PayablesPayments from "./pages/Accounting/Payables/Payments";
import PayablesRecurring from "./pages/Accounting/Payables/RecurringInvoices";
import NewRecurringBill from "./pages/Accounting/Payables/RightBarTasks/NewRecurringBill";
import ManuallyPostBills from "./pages/Accounting/Payables/RightBarTasks/ManuallyPostBills";
import PayablesPayBatches from "./pages/Accounting/Payables/PaymentBatches";
import EnterBill from "./pages/Accounting/Payables/RightBarTasks/EnterBill";

import SmartBillEntry from "./pages/Accounting/Payables/RightBarTasks/SmartBillEntry";
import ReadytoReview from "./pages/Accounting/Payables/RightBarTasks/SmartBillEntry/ReadytoReview";
import PayBills from "./pages/Accounting/Payables/RightBarTasks/PayBills";
import NewTenantPayable from "./pages/Accounting/Payables/RightBarTasks/NewTenantPayable";
import BankTransfersIncomplete from "./pages/Accounting/BankTransfers/Incomplete";
import BankTransfersCompleted from "./pages/Accounting/BankTransfers/Completed";
import HomeownerReceipt from "./pages/Accounting/Receivables/RightBarTasks/HomeownerReceipt/";
import TenantReceipt from "./pages/Accounting/Receivables/RightBarTasks/TenantReceipt";
import SubsidyReceipt from "./pages/Accounting/Receivables/RightBarTasks/SubsidyReceipt";
import OtherReceipt from "./pages/Accounting/Receivables/RightBarTasks/OtherReceipt";
import ApplicationFee from "./pages/Accounting/Receivables/RightBarTasks/ApplicationFee";
import BulkChargesAndCredits from "./pages/Accounting/Receivables/RightBarTasks/BulkChargesAndCredits";
import TenantCharge from "./pages/Accounting/Receivables/TenantCharge";
import HomeownerCharge from "./pages/Accounting/Receivables/RightBarTasks/HomeownerCharge";
import NewCommonCharge from "./pages/Accounting/Receivables/RightBarTasks/NewCommonCharge";
import BulkRecurringCharges from "./pages/Accounting/Receivables/RightBarTasks/BulkRecurringCharges";
import ChargeLateFees from "./pages/Accounting/Receivables/RightBarTasks/ChargeLateFees";
import NewTenantCredit from "./pages/Accounting/Receivables/RightBarTasks/NewTenantCredit";
import NewBankDeposit from "./pages/Accounting/Receivables/RightBarTasks/NewBankDeposit";
import ApplyCredits from "./pages/Accounting/Receivables/RightBarTasks/ApplyCredits";
import NewHomeownerCredit from "./pages/Accounting/Receivables/RightBarTasks/NewHomeownerCredit";

import OnlinePostingSettings from "./pages/UserProfile/OnlinePostingSettings";
import LetterTemplates from "./pages/Communication/Letters/LetterTemplates";
import MailingServices from "./pages/Communication/Letters/MailingServices";
import NewGuestCard from "./pages/Leasing/GuestCards/NewGuestCard";
import NewProperty from "./pages/PropertiesPage/NewProperty";
import NewAssociation from "./pages/PropertiesPage/NewAssociation";
import Tasks from "./pages/Tasks";
import Email from "./pages/Communication/Email";
import Chat from "./pages/Communication/Chat";
import BulkGuestCards from "./pages/Leasing/GuestCards/BulkGuestCards";
import ShowingAvailability from "./pages/Leasing/GuestCards/ShowingAvailability/index.js";
import MessageDetails from "./pages/Communication/Messages/MessageDetails.js/index.js";
import RentalApplicationCustomization from "./pages/UserProfile/RentalApplicationCustomization";
import CreateVacanciesList from "./pages/Leasing/Vacancies/CreateVacanciesList";
import BankTransfer from "./pages/Accounting/BankTransfers/Completed/BankTransfer";
import NewOwner from "./pages/People/Owners/NewOwner";
import NewVendor from "./pages/People/Vendors/NewVendor";
import NewRecurringWorkOrders from "./pages/Maintenance/RecurringWorkOrders/NewRecurringWorkOrders";

import GlAccount from "./pages/Accounting/GLAccounts/GlAccount";
import LeaseTemplates from "./pages/Leasing/Leases/LeaseTemplates";
import BulkPostVacancies from "./pages/Leasing/Vacancies/BulkPostVacancies";
import ManageLockboxes from "./pages/Leasing/GuestCards/ManageLockboxes";
import BulkUpdateApplicationFees from "./pages/Leasing/RentalApplications/BulkUpdateApplicationFees";
import NewServiceRequest from "./pages/Maintenance/WorkOrders/NewServiceRequest";
import NewManagementAgreement from "./pages/People/Owners/NewManagementAgreement";
import NewInspection from "./pages/Maintenance/Inspections/RightBarTasks/NewInspection";
import NewScheduledReport from "./pages/Reporting/ScheduledReports/NewScheduledReport";
import PostVacancyManually from "./pages/Leasing/Vacancies/PostVacancyManually";
import Property from "./pages/Leasing/Vacancies/PropertyTabs/Property";
import PropertyItemPage from "./pages/PropertiesPage/PropertyItemPage";
import Budget from "./pages/PropertiesPage/Budget";
import Marketing from "./pages/PropertiesPage/Marketing";
import Comparables from "./pages/PropertiesPage/Comparables";
import PropertyTabs from "./pages/Leasing/Vacancies/PropertyTabs";
import GuestCardItem from "./pages/Leasing/GuestCards/GuestCardItem";
import WorkOrderSettings from "./pages/UserProfile/GeneralSettings/WorkOrderSettings";
import SchedulingSettings from "./pages/UserProfile/GeneralSettings/Maintenance/SchedulingSettings";
import RentReminder from "./pages/UserProfile/GeneralSettings/Components/RentReminder";
import TextingSettings from "./pages/UserProfile/GeneralSettings/Communication/TextingSettings";
import MoveInTenant from "./pages/People/Tenants/MoveInTenant";
import Payments from "./pages/Accounting/Receivables/Payments";
import OwnerCommunicationSettings from "./pages/UserProfile/GeneralSettings/Communication/OwnerCommunicationSettings";
import AutomaticCommunicationSettings from "./pages/UserProfile/GeneralSettings/Communication/AutomaticCommunicationSettings";
import UploadBulkBill from "./pages/Accounting/Payables/Invoices/UploadBulkBill";
import NewTenantLetterTemplate from "./pages/Communication/Letters/LetterTemplates/NewTenantLetterTemplate";
import NewOwnerLetterTemplate from "./pages/Communication/Letters/LetterTemplates/NewOwnerLetterTemplate";
import NewVendorLetterTemplate from "./pages/Communication/Letters/LetterTemplates/NewVendorLetterTemplate";
import BillsItem from "./pages/Accounting/Payables/Invoices/BillsItem";
import OwnerPortalAnnouncement from "./pages/People/Owners/OwnerPortalAnnouncement";
import EndManagement from "./pages/PropertiesPage/EndManagement";
import UtilityBillDetails from "./pages/Accounting/Payables/Invoices/UtilityBillDetails";
import BulkPropertyReport from "./pages/Reporting/Reports/BulkPropertyReports";
import BulkUpdateOwnerPacketSettings from "./pages/Reporting/Reports/BulkUpdateOwnerPacketSettings";
import PDFFormTemplates from "./pages/Leasing/Leases/PDFFormTemplates";
import ShowingsSettings from "./pages/UserProfile/ShowingsSettings";
import ManageManualFields from "./pages/Leasing/Leases/LeaseTemplates/ManageManualFields";
import LeaseSettings from "./pages/UserProfile/LeaseSettings";
import AddLockbox from "./pages/Leasing/GuestCards/AddLockbox";
import { DashboardCards } from "./pages/Dashboard/Data/DashboardData";
import LockBox from "./pages/Accounting/Receivables/Payments/LockBox";
import VendorACH from "./pages/People/Vendors/VendorACH";
import SurveysDetails from "./pages/Reporting/Surveys/components/SurveysDetails";
import TenantDetails from "./pages/People/Tenants/TenantDetails";
import AddActivity from "./pages/People/Tenants/AddActivity";
import BankAccounts from "./pages/Accounting/BankAccounts";
import RentIncrease from "./pages/PropertiesPage/RentIncrease";
import LateFeePolicy from "./pages/People/Tenants/MoveInTenant/components/LateFeePolicy";
import PaymentsBatch from "./pages/Accounting/Payables/PaymentBatches/PaymentsBatch";
import ReceiptDetails from "./pages/Accounting/Receivables/Payments/ReceiptDetails";
import ChargeDetails from "./pages/Accounting/Receivables/Invoices/ChargeDetails";
import RecurringBillDetails from "./pages/Accounting/Payables/RecurringInvoices/RecurringBillDetails";
import BankDepositeDetails from "./pages/Accounting/Receivables/BankDeposits/BankDepositeDetails";
import BankAccountDetails from "./pages/Accounting/BankAccounts/BankAccountDetails";
import OwnerDetails from "./pages/People/Owners/OwnerDetails";
import VendorDetails from "./pages/People/Vendors/VendorDetails";
import WorkOrderDetails from "./pages/Maintenance/WorkOrders/WorkOrderDetails";
import ManageEstimates from "./pages/Maintenance/WorkOrders/WorkOrderDetails/ManageEstimates";
import RecurringWorkOrderDetails from "./pages/Maintenance/RecurringWorkOrders/RecurringWorkOrderDetails";
import OwnerACH from "./pages/People/Owners/OwnerACH";
import BulkPortalCommunicationSettings from "./pages/UserProfile/GeneralSettings/Communication/BulkPortalCommunicationSettings";
import ScheduledReportsDetails from "./pages/Reporting/ScheduledReports/Components/ScheduledReportsDetails";
import PrepareRenewalOffer from "./pages/Leasing/Renewals/PrepareRenewalOffer";
import InspectionInfo from "./pages/Maintenance/Inspections/RightBarTasks/InspectionInfo";
import InspectionItemPage from "./pages/Maintenance/Inspections/RightBarTasks/InspectionItemPage";
import PrintWithImages from "./pages/Maintenance/Inspections/RightBarTasks/InspectionItemPage/components/PrintInspections";
import NewInspectionTemplate from "./pages/Maintenance/Inspections/RightBarTasks/NewInspectionTemplate";
import NewTemplate from "./pages/Maintenance/Inspections/RightBarTasks/NewInspectionTemplate/components/NewTemplate";
import NewLeaseTemplate from "./pages/Leasing/Leases/LeaseTemplates/NewLeaseTemplate/NewLeaseTemplate";
import NewAddendum from "./pages/Leasing/Leases/LeaseTemplates/NewLeaseTemplate/NewAddendum";
import AddNewPDFFormTemplate from "./pages/Leasing/Leases/PDFFormTemplates/AddNewPDFFormTemplate";
import NewKeys from "./pages/PropertiesPage/PropertyItemPage/NewKeys";
import NewActivity from "./pages/PropertiesPage/PropertyItemPage/NewActivity";
import RentalApplicationDetails from "./pages/Leasing/RentalApplications/RentalApplicationDetails";
import PaymentDetails from "./pages/Accounting/Payables/Payments/PaymentDetails";
import CustomizeWorkOrderPage from "./pages/Maintenance/WorkOrders/CustomizeWorkOrder";
import CarrierComplianceSettings from "./pages/UserProfile/GeneralSettings/Communication/TextingSettings/CarrierComplianceSettings";
import Tags from "./pages/UserProfile/GeneralSettings/Tags";
import ManagementAgreements from "./pages/People/Owners/ManagementAgreements";
import ScheduledReportItemPage from "./pages/Reporting/ScheduledReports/ScheduledReportItemPage";
import NewTenant from "./pages/People/Tenants/NewTenant";
import Library from "./pages/Tasks/Library";
import TasksReports from "./pages/Tasks/TasksReports";
import Inbox from "./pages/Tasks/Inbox";
import SendLeaseAddendum from "./pages/Leasing/Leases/SendLeaseAddendum";
import SendOwnerPacket from "./pages/Communication/Letters/SendOwnerPacket";
import TaskProperty from "./pages/Tasks/Library/TaskProperty";
import Scheduled from "./pages/Tasks/Library/Scheduled";
import PrivateLibrary from "./pages/Tasks/Library/PrivateLibrary";
import PrivateLibraryItemPage from "./pages/Tasks/Library/PrivateLibrary/PrivateLibraryItemPage";
import WorkflowRunsPage from "./pages/Tasks/TasksReports/WorkflowRunsPage";
import LibraryPropertyItemPage from "./pages/Tasks/Library/LibraryPropertyItemPages";
import Viewing from "./pages/Tasks/Library/LibraryPropertyItemPages/Viewing";
import LibraryScheduled from "./pages/Tasks/Library/Scheduled";
import LibraryScheduleItemPage from "./pages/Tasks/Library/Scheduled/components/LibraryScheduledTable/LibraryScheduleItemPage";
import ReportsAnalyticsPage from "./pages/Tasks/TasksReports/ReportsAnalyticsPage";
// import User from "./pages/Tasks/Library/User";
import Register from "./pages/Auth/Register";
import Login from "./pages/Auth/Login";
import Reset from "./pages/Auth/Reset";
import PrivateRoutes from "./pages/Auth/PrivateRoutes";

import NewPassword from "./pages/Auth/NewPassword";
import UnitTurnsItemPage from "./pages/Maintenance/UnitTurns/UnitTurnItemPage";
import InboxItemPages from "./pages/Tasks/Inbox/inboxItemPages";
import WorkFlowRunsTable from "./pages/Tasks/TasksReports/WorkflowRunsPage/components/WorkFlowRunsTable";
import AssignedMeWorkFlows from "./pages/Tasks/TasksReports/AssignedMeWorkFlows";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route path="/" element={<MainLayout />}>
            {/* Sidebar Pages Links start*/}
            <Route index element={<Dashboard />} />
            <Route path="/CalendarPage" element={<CalendarPage />} />
            <Route path="/properties" element={<PropertiesPage />} />

            <Route path="/whats-new" element={<WhatsNewPage />} />
            <Route path="/properties/new" element={<NewProperty />} />
            <Route path="/association/new" element={<NewAssociation />} />
            <Route
              path="/activity/new_activity/:id"
              element={<NewActivity />}
            />
            <Route path="/key/new_key/:id" element={<NewKeys />} />
            <Route
              path="/send_lease_addendum"
              element={<SendLeaseAddendum />}
            />

            {/* Leasing Tab Links start*/}

            <Route path="/leasing" element={<Leasing />}>
              <Route path="/leasing/vacancies" element={<Vacancies />} />
              <Route
                path="/leasing/vacancies/create-vacancies"
                element={<CreateVacanciesList />}
              />
              <Route
                path="/leasing/vacancies/bulk-post-vacancies"
                element={<BulkPostVacancies />}
              />
              <Route path="/leasing/guest-cards" element={<GuestCards />} />
              <Route
                path="/leasing/guest-cards/new-guest-card"
                element={<NewGuestCard />}
              />

              <Route
                path="/leasing/guest-cards/manage-lockboxes"
                element={<ManageLockboxes />}
              />
              <Route
                path="/leasing/guest-cards/bulk-guest-cards"
                element={<BulkGuestCards />}
              />
              <Route
                path="/leasing/guest-cards/:id"
                element={<GuestCardItem />}
              />

              <Route
                path="/leasing/guest-cards/bulk"
                element={<BulkGuestCards />}
              />
              <Route
                path="/leasing/rental-applications"
                element={<RentalApplications />}
              />
              <Route
                path="/leasing/rental-applications/rental-application/:id"
                element={<RentalApplicationDetails />}
              />
              <Route
                path="/leasing/rental-applications/NewRentalApplications"
                element={<NewRentalApplications />}
              />
              <Route
                path="/leasing/rental-applications/bulk-update-application-fees"
                element={<BulkUpdateApplicationFees />}
              />

              <Route
                path="/leasing/guest-cards/new-guest-card"
                element={<NewGuestCard />}
              />
              <Route
                path="/leasing/guest-cards/bulk"
                element={<BulkGuestCards />}
              />
              <Route
                path="/leasing/rental-applications"
                element={<RentalApplications />}
              />
              <Route
                path="/leasing/rental-applications/NewRentalApplications"
                element={<NewRentalApplications />}
              />
              <Route path="/leasing/leases" element={<Leases />} />
              <Route
                path="/leasing/leases/lease-templates"
                element={<LeaseTemplates />}
              />
              <Route path="/leasing/renewals" element={<Renewals />} />
            </Route>
            <Route
              path="/leasing/renewals/:id"
              element={<PrepareRenewalOffer />}
            ></Route>

            <Route
              path="/leasing/leases/pdf-form-templates"
              element={<PDFFormTemplates />}
            />
            <Route
              path="/leasing/leases/lease-templates/manage-manually-entered-fields"
              element={<ManageManualFields />}
            />
            <Route
              path="/leasing/guest-cards/manage-lockboxes/add-lockbox"
              element={<AddLockbox />}
            />
            <Route
              path="/showing-availability"
              element={<ShowingAvailability />}
            />

            {/* Leasing Tab Links End*/}

            {/* People Tab Links Start*/}

            <Route path="/people" element={<People />}>
              <Route path="/people/tenants" element={<Tenants />} />
              <Route
                path="/people/tenants/new_tenant/:id"
                element={<NewTenant />}
              />
              <Route
                path="/people/tenants/tenant-details/:id"
                element={<TenantDetails />}
              />
              <Route
                path="/people/tenants/move-in-tenant"
                element={<MoveInTenant />}
              />

              <Route
                path="/people/tenants/tenant-details/:id/late-fee-policy"
                element={<LateFeePolicy />}
              />
              <Route path="/people/owners" element={<Owners />} />
              <Route
                path="/people/owners/owners-details/:id"
                element={<OwnerDetails />}
              />
              <Route path="/people/owners/new" element={<NewOwner />} />
              <Route path="/people/owners/owner-ach" element={<OwnerACH />} />
              <Route path="/people/vendors" element={<Vendors />} />
              <Route
                path="/people/vendors/vendor-details/:id"
                element={<VendorDetails />}
              />
              <Route path="/people/vendors/new" element={<NewVendor />} />
              <Route
                path="/people/vendors/new/vendor-ACH-setup"
                element={<VendorACH />}
              />
            </Route>

            <Route
              path="/management_agreement_documents/new"
              element={<NewManagementAgreement />}
            />
            <Route path="/add-new-activity" element={<AddActivity />} />
            <Route
              path="/management-agreements-page"
              element={<ManagementAgreements />}
            />

            {/* People Tab Links End*/}

            {/* property tabs links start  */}

            <Route path="/property-tabs" element={<PropertyTabs />}>
              <Route
                path="/property-tabs/:id"
                element={<PostVacancyManually />}
              />
              {/* <Route path="/property-tabs/property:id" element={<Property />} /> */}
              <Route path="/property-tabs/property:id" element={<Property />} />
              <Route
                path="/property-tabs/property/:id"
                element={<PropertyItemPage />}
              />
              <Route path="/property-tabs/budget/:id" element={<Budget />} />
              <Route
                path="/property-tabs/marketing/:id"
                element={<Marketing />}
              />
              <Route
                path="/property-tabs/comparabels/:id"
                element={<Comparables />}
              />
            </Route>

            <Route path="/rent_increase" element={<RentIncrease />} />

            <Route
              path="/property-page/end-management/:id"
              element={<EndManagement />}
            />

            {/* property tabs links end  */}

            {/* Accounting Tab Links Start*/}

            <Route path="/accounting" element={<Accounting />}>
              <Route
                path="/accounting/receivables_payments"
                element={<Receivables />}
              >
                <Route
                  index
                  element={
                    <Navigate to="/accounting/receivables_payments/reciepts" />
                  }
                ></Route>
                <Route
                  path="/accounting/receivables_payments/reciepts"
                  element={<Payments />}
                ></Route>
                <Route
                  path="/accounting/receivables_payments/reciepts/:id"
                  element={<ReceiptDetails />}
                />
                <Route
                  path="/accounting/receivables_payments/reciepts/tenant_receipts/new"
                  element={<TenantReceipt />}
                />
                <Route
                  path="/accounting/receivables_payments/reciepts//HomeownerReceipt"
                  element={<HomeownerReceipt />}
                />
                <Route
                  path="/accounting/receivables_payments/reciepts/otherReceipt"
                  element={<OtherReceipt />}
                />
                <Route
                  path="/accounting/receivables_payments/reciepts/subsidyreceipt"
                  element={<SubsidyReceipt />}
                />
                <Route
                  path="/accounting/receivables_payments/reciepts/newapplicationfee"
                  element={<ApplicationFee />}
                />
                <Route
                  path="/accounting/receivables_payments/reciepts/applycredits"
                  element={<ApplyCredits />}
                />

                <Route
                  path="/accounting/receivables_payments/chargelatefees"
                  element={<ChargeLateFees />}
                />

                <Route
                  path="/accounting/receivables_payments/invoices"
                  element={<ReceivableInvoices />}
                />
                <Route
                  path="/accounting/receivables_payments/invoices/:id"
                  element={<ChargeDetails />}
                />
                <Route
                  path="/accounting/receivables_payments/invoices/tenantcharge"
                  element={<TenantCharge />}
                />

                <Route
                  path="/accounting/receivables_payments/invoices/bulkchargesandcredits"
                  element={<BulkChargesAndCredits />}
                />
                <Route
                  path="/accounting/receivables_payments/bank_deposits"
                  element={<ReceivableBankDeposits />}
                />
                <Route
                  path="/accounting/receivables_payments/bank_deposits/:id"
                  element={<BankDepositeDetails />}
                />
                <Route
                  path="/accounting/receivables_payments/bank_deposits/NewBankDeposit"
                  element={<NewBankDeposit />}
                />

                <Route
                  path="/accounting/receivables_payments/invoices/homeownercharge"
                  element={<HomeownerCharge />}
                />
                <Route
                  path="/accounting/receivables_payments/invoices/NewCommonCharge"
                  element={<NewCommonCharge />}
                />
                <Route
                  path="/accounting/receivables_payments/invoices/bulkrecurringcharges"
                  element={<BulkRecurringCharges />}
                />
                <Route
                  path="/accounting/receivables_payments/invoices/newtenantcredit"
                  element={<NewTenantCredit />}
                />
                <Route
                  path="/accounting/receivables_payments/invoices/newhomeownercredit"
                  element={<NewHomeownerCredit />}
                />
                <Route
                  path="/accounting/receivables_payments/lockbox"
                  element={<LockBox />}
                />
              </Route>
              <Route path="/accounting/payables_bills" element={<Payables />}>
                <Route
                  index
                  element={<Navigate to="/accounting/payables_bills/bills" />}
                ></Route>
                <Route
                  path="/accounting/payables_bills/bills"
                  element={<PayablesInvoices />}
                />
                <Route
                  path="/accounting/payables_bills/bills/smartbillentry"
                  element={<SmartBillEntry />}
                />
                <Route
                  path="/accounting/payables_bills/bills/utility-bill-details"
                  element={<UtilityBillDetails />}
                />
                <Route
                  path="/accounting/payables_bills/bills/newtenantpayable"
                  element={<NewTenantPayable />}
                />
                <Route
                  path="/accounting/payables_bills/bills/upload-bulk-bills"
                  element={<UploadBulkBill />}
                />

                <Route
                  path="/accounting/payables_bills/bills/bills-item/:id"
                  element={<BillsItem />}
                />

                <Route
                  path="/accounting/payables_bills/recurring_invoices"
                  element={<PayablesRecurring />}
                />
                <Route
                  path="/accounting/payables_bills/recurring_invoices/:id"
                  element={<RecurringBillDetails />}
                />
                <Route
                  path="/accounting/payables_bills/recurring_invoices/newrecurringbill"
                  element={<NewRecurringBill />}
                />

                <Route
                  path="/accounting/payables_bills/smartbillentry/:id"
                  element={<ReadytoReview />}
                />
                <Route
                  path="/accounting/payables_bills/paybills"
                  element={<PayBills />}
                />
                <Route
                  path="/accounting/payables_bills/recurring_invoices/manually_post_bills"
                  element={<ManuallyPostBills />}
                />
                <Route
                  path="/accounting/payables_bills/payments"
                  element={<PayablesPayments />}
                />
                <Route
                  path="/accounting/payables_bills/payments/payment/:id"
                  element={<PaymentDetails />}
                />

                <Route
                  path="/accounting/payables_bills/payment_batches"
                  element={<PayablesPayBatches />}
                />
                <Route
                  path="/accounting/payables_bills/payment_batches/:id"
                  element={<PaymentsBatch />}
                />

                <Route
                  path="/accounting/payables_bills/bills/enter-bils"
                  element={<EnterBill />}
                />
              </Route>
              <Route
                path="/accounting/bank_accounts"
                element={<BankAccounts />}
              ></Route>
              <Route
                path="/accounting/bank_accounts/bank-account-details/:id"
                element={<BankAccountDetails />}
              ></Route>
              <Route
                path="/accounting/bank_transfers_incomplete"
                element={<BankTransfers />}
              >
                <Route
                  index
                  element={
                    <Navigate to="/accounting/bank_transfers_incomplete/incomplete" />
                  }
                ></Route>
                <Route
                  path="/accounting/bank_transfers_incomplete/incomplete"
                  element={<BankTransfersIncomplete />}
                />
                <Route
                  path="/accounting/bank_transfers_incomplete/completed"
                  element={<BankTransfersCompleted />}
                />
                <Route
                  path="/accounting/bank_transfers_incomplete/completed/bank-transfer/:id"
                  element={<BankTransfer />}
                />
              </Route>
              <Route path="/accounting/gl-accounts" element={<GLAccounts />} />
              <Route
                path="/accounting/gl-accounts/gl-account/:id"
                element={<GlAccount />}
              />
            </Route>

            {/* Accounting Tab Links End */}

            {/* Maintenance Tab Links Start */}

            <Route path="/maintenance" element={<Maintenance />}>
              <Route path="/maintenance/work-orders" element={<WorkOrders />} />
              <Route
                path="/maintenance/work-orders/manage-estimates/:workOrderNumber"
                element={<ManageEstimates />}
              />
              <Route
                path="/maintenance/work-orders/work-order/:id"
                element={<WorkOrderDetails />}
              />
              <Route
                path="/maintenance/work-orders/customize"
                element={<CustomizeWorkOrderPage />}
              />

              <Route
                path="/maintenance/work-orders/service-requests/new"
                element={<NewServiceRequest />}
              />
              <Route
                path="/maintenance/recurring-work-orders"
                element={<RecurringWorkOrders />}
              />
              <Route
                path="/maintenance/recurring-work-orders/recurring-work-order/:id"
                element={<RecurringWorkOrderDetails />}
              />
              <Route
                path="/maintenance/recurring-work-orders/new"
                element={<NewRecurringWorkOrders />}
              />
              <Route
                path="/maintenance/inspections"
                element={<Inspections />}
              />
              <Route path="/maintenance/unit-turns" element={<UnitTurns />} />
              <Route
                path="/maintenance/unit-turns/:id"
                element={<UnitTurnsItemPage />}
              />
            </Route>

            {/* Maintenance Tab Links End */}

            {/* Reporting Tab Links Start */}

            <Route path="/reporting" element={<Reporting />}>
              <Route path="/reporting/reports" element={<Reports />} />
              <Route
                path="/reporting/reports/bulk-property-reports"
                element={<BulkPropertyReport />}
              />
              <Route
                path="/reporting/scheduled-reports"
                element={<ScheduledReports />}
              />

              <Route
                path="/reporting/scheduled-reports/scheduled-reports-details"
                element={<ScheduledReportsDetails />}
              />
              <Route
                path="/reporting/scheduled-reports/new"
                element={<NewScheduledReport />}
              />
              <Route
                path="/reporting/scheduled-reports/item"
                element={<ScheduledReportItemPage />}
              />

              <Route path="/reporting/surveys" element={<Surveys />} />

              <Route
                path="/reporting/surveys/details"
                element={<SurveysDetails />}
              />

              <Route path="/reporting/metrics_pricing" element={<Metrics />}>
                <Route
                  index
                  element={<Navigate to="/reporting/metrics_pricing/pricing" />}
                ></Route>
                <Route
                  path="/reporting/metrics_pricing/pricing"
                  element={<PricingMetrics />}
                />
                <Route
                  path="/reporting/metrics_pricing/data_diagnostic"
                  element={<DataDiagnostic />}
                />
                <Route
                  path="/reporting/metrics_pricing/tenant_insurance_coverage"
                  element={<TenantInsCoverage />}
                />
              </Route>
            </Route>

            <Route
              path="/reporting/bulk-update-owner-packet-settinsg"
              element={<BulkUpdateOwnerPacketSettings />}
            />

            {/* Reporting Tab Links End */}

            {/* Communication Tab Links Start */}

            <Route path="/communication" element={<Communication />}>
              <Route
                path="/communication/letters_templates"
                element={<Letters />}
              >
                <Route
                  path="/communication/letters_templates/send_owner_packets"
                  element={<SendOwnerPacket />}
                />
                <Route
                  index
                  element={
                    <Navigate to="/communication/letters_templates/templates" />
                  }
                ></Route>
                <Route
                  path="/communication/letters_templates/templates"
                  element={<LetterTemplates />}
                />
                <Route
                  path="/communication/letters_templates/templates/new-tenant-letter-template"
                  element={<NewTenantLetterTemplate />}
                />
                <Route
                  path="/communication/letters_templates/templates/new-owner-letter-template"
                  element={<NewOwnerLetterTemplate />}
                />
                <Route
                  path="/communication/letters_templates/templates/new-vendor-letter-template"
                  element={<NewVendorLetterTemplate />}
                />
                <Route
                  path="/communication/letters_templates/mailing_services"
                  element={<MailingServices />}
                />
                <Route
                  path="/communication/letters_templates/mailing_services"
                  element={<MailingServices />}
                />
              </Route>
              <Route
                path="/communication/letters_templates/owner-portal-announcement"
                element={<OwnerPortalAnnouncement />}
              />
              <Route
                path="/communication/resident-forms"
                element={<ResidentForms />}
              />
              <Route path="/communication/messages" element={<Messages />} />
              <Route path="/communication/email" element={<Email />} />
              <Route path="/communication/chat" element={<Chat />} />
              <Route
                path="/communication/messages/:id"
                element={<MessageDetails />}
              />
            </Route>

            <Route path="/tasks" element={<Tasks />}>
              <Route path="/tasks/library" element={<Library />}>
                <Route index element={<TaskProperty />} />
                {/* <Route path="/tasks/library/user" element={<User />} /> */}
                <Route
                  path="/tasks/library/scheduled"
                  element={<Scheduled />}
                />
              </Route>
              <Route path="/tasks/reports" element={<TasksReports />}>
                <Route
                  path="/tasks/reports/active_workflow"
                  element={<WorkflowRunsPage />}
                />
                <Route
                  path="/tasks/reports/assigned_me"
                  element={<AssignedMeWorkFlows />}
                />
              </Route>
              <Route path="/tasks/inbox" element={<Inbox />} />
            </Route>

            {/* Communication Tab Links End */}
            <Route
              path="/generalsettings/communication/rent-reminder-settings"
              element={<RentReminder />}
            />

            {/* Sidebar Links End */}

            <Route path="/mysettings/:id" element={<MySettings />} />
            <Route path="/generalsettings" element={<GeneralSettings />} />

            {/* General Settings Pages Links Start*/}
            <Route
              path="/generalsettings/bills-approval-flow"
              element={<BillsApprovalFlow />}
            />
            <Route
              path="/generalsettings/accounting-settings"
              element={<AccountingSettings />}
            />
            <Route
              path="/generalsettings/accounting-periods"
              element={<AccountingPeriods />}
            />
            <Route
              path="/generalsettings/management-fee-settings"
              element={<ManagementFeeSettings />}
            />
            <Route
              path="/generalsettings/property-groups"
              element={<PropertyGroups />}
            />
            <Route
              path="/generalsettings/new-property-groups"
              element={<NewPropertyGroups />}
            />
            <Route
              path="/generalsettings/manage-users"
              element={<ManageUsers />}
            />
            <Route
              path="/generalsettings/user-roles-permissions"
              element={<ManageRoles />}
            />
            <Route
              path="/generalsettings/management-agreement-templates"
              element={<AgreementTemplates />}
            />
            <Route
              path="/generalsettings/gl-account-permissions"
              element={<GlAccountPermissions />}
            />
            <Route path="/generalsettings/new-users" element={<NewUser />} />
            <Route
              path="/generalsettings/rental-application-fees"
              element={<RentalApplicationFees />}
            />
            <Route
              path="/generalsettings/rental-application-fees/update-fees"
              element={<UpdateApplicationFees />}
            />
            <Route
              path="/generalsettings/screening-criteria"
              element={<ScreeningCriteria />}
            />
            <Route
              path="/generalsettings/screening-criteria/:id"
              element={<Template />}
            />
            <Route
              path="/generalsettings/online-posting-settings"
              element={<OnlinePostingSettings />}
            />
            <Route
              path="/generalsettings/rental-application-customization"
              element={<RentalApplicationCustomization />}
            />
            <Route
              path="/generalsettings/communication/bulk-portal-communication"
              element={<BulkPortalCommunicationSettings />}
            />

            <Route
              path="generalsettings/maintenance/work-order-settings"
              element={<WorkOrderSettings />}
            />
            <Route
              path="/generalsettings/maintenance/schedualing-settings"
              element={<SchedulingSettings />}
            />
            <Route
              path="/generalsettings/communication/text-settings"
              element={<TextingSettings />}
            />
            <Route
              path="/generalsettings/communication/carrier-compliance-settings/"
              element={<CarrierComplianceSettings />}
            />
            <Route
              path="/generalsettings/communication/owner-communication-setting"
              element={<OwnerCommunicationSettings />}
            />
            <Route
              path="/generalsettings/showings-settings"
              element={<ShowingsSettings />}
            />

            <Route path="/tasks" element={<Tasks />}>
              <Route
                path="/tasks/library/Viewing/:category"
                element={<Viewing />}
              />
              <Route path="/tasks/library" element={<Library />}>
                <Route index element={<TaskProperty />} />
                <Route path="/tasks/library/user" element={<Library />} />
                <Route
                  path="/tasks/library/library-scheduled"
                  element={<Scheduled />}
                />
                <Route
                  path="/tasks/library/:category"
                  element={<LibraryPropertyItemPage />}
                />
                <Route
                  path="/tasks/library/privateLibraryItemPage/:category"
                  element={<PrivateLibraryItemPage />}
                />
                <Route
                  path="/tasks/library/privateLibrary"
                  element={<PrivateLibrary />}
                />
              </Route>
              <Route path="/tasks/reports" element={<TasksReports />}>
                <Route index element={<WorkflowRunsPage />} />
                <Route
                  path="/tasks/reports/workflow"
                  element={<WorkflowRunsPage />}
                />
                <Route
                  path="/tasks/reports/reportsanalytics"
                  element={<ReportsAnalyticsPage />}
                />
                Í
              </Route>
              <Route path="/tasks/inbox" element={<Inbox />} />
              <Route path="/tasks/inbox/:id" element={<InboxItemPages />} />

              <Route
                path="/tasks/library/library-scheduled/item-page/:id"
                element={<LibraryScheduleItemPage />}
              />
            </Route>

            {/* Communication Tab Links End */}
            <Route
              path="/generalsettings/communication/rent-reminder-settings"
              element={<RentReminder />}
            />

            {/* Sidebar Links End */}

            <Route path="/mysettings" element={<MySettings />} />
            <Route path="/generalsettings" element={<GeneralSettings />} />
            <Route
              path="generalsettings/maintenance/work-order-settings"
              element={<WorkOrderSettings />}
            />
            <Route
              path="/generalsettings/maintenance/schedualing-settings"
              element={<SchedulingSettings />}
            />
            <Route
              path="/generalsettings/communication/text-settings"
              element={<TextingSettings />}
            />
            <Route
              path="/generalsettings/communication/carrier-compliance-settings/"
              element={<CarrierComplianceSettings />}
            />
            <Route
              path="/generalsettings/communication/owner-communication-setting"
              element={<OwnerCommunicationSettings />}
            />
            <Route
              path="/generalsettings/showings-settings"
              element={<ShowingsSettings />}
            />

            <Route
              path="/generalsettings/lease-settings"
              element={<LeaseSettings />}
            />
            <Route
              path="/generalsettings/communication/automatic-communication-settings"
              element={<AutomaticCommunicationSettings />}
            />

            <Route path="/generalsettings/manage-tags" element={<Tags />} />
            {/* Manage Company Settings Tab Links Start */}

            <Route
              path="/generalsettings/manage-company-settings/company-settings"
              element={<ManageCompanySettings />}
            >
              <Route index element={<CompanySettings />} />
              <Route
                path="/generalsettings/manage-company-settings/company-settings/logo-settings"
                element={<LogoSettings />}
              />
              <Route
                path="/generalsettings/manage-company-settings/company-settings/portfolio"
                element={<Portfolio />}
              />
            </Route>

            {/* Manage Company Settings Tab Links End */}

            {/* General Settings Pages Links End*/}

            {/* <Route path="/SendOtpCode" element={<SendOtpCode />} /> */}
            <Route path="/LoginPage" element={<LoginPage />} />
            <Route
              path="/UserPhoneVerification"
              element={<UserPhoneVerification />}
            />
          </Route>
          <Route path="/inspection" element={<NewInspection />}>
            <Route index element={<InspectionInfo />} />
            <Route path="/inspection/:id" element={<InspectionItemPage />} />
            <Route
              path="/inspection/print_inspection"
              element={<PrintWithImages />}
            />
            <Route
              path="/inspection/new_inspection_template"
              element={<NewInspectionTemplate />}
            />
            <Route
              path="/inspection/new_inspection_template/:id"
              element={<NewTemplate />}
            />
          </Route>

          <Route
            path="/new_lease_template"
            element={<NewLeaseTemplate />}
          ></Route>
          <Route path="/new_addendum" element={<NewAddendum />}></Route>

          <Route
            path="/leasing/leases/pdf-form-templates/add_new_pdf"
            element={<AddNewPDFFormTemplate />}
          ></Route>
        </Route>
        <Route path="/register" element={<Register />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/reset" element={<Reset />}></Route>
        <Route path="/verify" element={<NewPassword />}></Route>
      </Routes>
    </div>
  );
}

export default App;
